/* MOBIPARK全国パートナー（sections/shoplist-search.liquid）
   エリア切り替え・店舗種別/目的の絞り込み・並べ替え・さらに表示・0件表示を制御する。
   店舗カードは Liquid が全件 HTML 出力済み（snippets/partner-store-card.liquid）。JS 無効時は全件表示のまま。 */
(function () {
  'use strict';

  var root = document.querySelector('[data-sl-search]');
  if (!root) return;

  /* 近隣エリアの対応表 */
  var NEARBY = {
    'hokkaido-tohoku': ['kanto', 'chubu-hokuriku'],
    'kanto': ['hokkaido-tohoku', 'chubu-hokuriku'],
    'chubu-hokuriku': ['kanto', 'kinki'],
    'kinki': ['chubu-hokuriku', 'chugoku-shikoku'],
    'chugoku-shikoku': ['kinki', 'kyushu-okinawa'],
    'kyushu-okinawa': ['chugoku-shikoku', 'kinki']
  };
  var SERVICE_ATTR = { 'sell': 'data-sell', 'test-ride': 'data-test-ride', 'repair': 'data-repair', 'deliver': 'data-deliver' };
  var SP_QUERY = window.matchMedia('(max-width: 896px)');

  var list = root.querySelector('[data-sl-list]');
  var cards = Array.prototype.slice.call(list.querySelectorAll('.psc'));
  var areaBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sl-region]'));
  var serviceBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sl-service]'));
  var tierBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sl-tier]'));
  var headLabel = root.querySelector('[data-sl-head-label]');
  var headEn = root.querySelector('[data-sl-head-en]');
  var headCount = root.querySelector('[data-sl-head-count]');
  var moreWrap = root.querySelector('[data-sl-more-wrap]');
  var moreBtn = root.querySelector('[data-sl-more]');
  var moreLabel = root.querySelector('[data-sl-more-label]');
  var emptyArea = root.querySelector('[data-sl-empty="area"]');
  var emptyFilter = root.querySelector('[data-sl-empty="filter"]');
  var head = root.querySelector('[data-sl-head]');

  /* エリア情報（ナビのボタンから取得） */
  var regions = {};
  var regionOrder = [];
  areaBtns.forEach(function (btn, i) {
    var key = btn.getAttribute('data-sl-region');
    regionOrder.push(key);
    regions[key] = {
      btn: btn,
      num: ('0' + (i + 1)).slice(-2),
      label: btn.getAttribute('data-label'),
      name: btn.getAttribute('data-name'),
      en: btn.getAttribute('data-en'),
      count: parseInt(btn.getAttribute('data-count'), 10) || 0
    };
  });

  var state = { region: null, service: 'all', tier: null, shown: 0 };

  /* 並び順: 区分（プレミアム → 取扱店 → サービス）→ 表示順 → 登録順。条件に依存しないので初回に1度だけ並べ替える */
  cards.forEach(function (c, i) { c._slIndex = i; });
  cards.sort(function (a, b) {
    var ra = +a.getAttribute('data-tier-rank') || 9, rb = +b.getAttribute('data-tier-rank') || 9;
    if (ra !== rb) return ra - rb;
    var oa = +a.getAttribute('data-order'), ob = +b.getAttribute('data-order');
    if (isNaN(oa)) oa = 9999;
    if (isNaN(ob)) ob = 9999;
    if (oa !== ob) return oa - ob;
    return a._slIndex - b._slIndex;
  });
  cards.forEach(function (c) { list.appendChild(c); });

  /* 区分の区切り線。全幅の行なので、次の区分のカードは必ず左列から始まる */
  var tierHeads = {};
  cards.forEach(function (c) {
    var key = c.getAttribute('data-tier');
    if (!key || tierHeads[key]) return;
    var li = document.createElement('li');
    li.className = 'sl-tier-head';
    li.setAttribute('aria-hidden', 'true');
    li.hidden = true;
    list.insertBefore(li, c);
    tierHeads[key] = li;
  });

  function step() {
    return parseInt(root.getAttribute(SP_QUERY.matches ? 'data-step-sp' : 'data-step-pc'), 10) || (SP_QUERY.matches ? 6 : 10);
  }

  function matches(card, region, service, tier) {
    if (card.getAttribute('data-region') !== region) return false;
    if (service !== 'all' && card.getAttribute(SERVICE_ATTR[service]) !== 'true') return false;
    if (tier && card.getAttribute('data-tier') !== tier) return false;
    return true;
  }

  function countFor(region, service, tier) {
    var n = 0;
    cards.forEach(function (c) { if (matches(c, region, service, tier)) n++; });
    return n;
  }

  function serviceLabel(service) {
    var btn = root.querySelector('[data-sl-service="' + service + '"]');
    return btn ? btn.textContent.trim() : '';
  }

  function tierLabel(tier) {
    var btn = root.querySelector('[data-sl-tier="' + tier + '"]');
    return btn ? btn.textContent.trim() : tier;
  }

  function setAreaNames(el, name) {
    Array.prototype.forEach.call(el.querySelectorAll('[data-sl-area-name]'), function (s) { s.textContent = name; });
  }

  /* 近隣エリアのチップ。filtered=true のときは同じ条件での件数を添える */
  function renderNearby(el, filtered) {
    Array.prototype.forEach.call(el.querySelectorAll('[data-sl-nearby]'), function (box) {
      box.innerHTML = '';
      (NEARBY[state.region] || []).forEach(function (key) {
        var r = regions[key];
        if (!r) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sl-chip sl-chip--nearby';
        var n = filtered ? countFor(key, state.service, state.tier) : r.count;
        b.textContent = r.num + ' ' + r.label + (filtered ? '（' + n + '件）' : '') + '  ▶';
        b.addEventListener('click', function () {
          setRegion(key, true);
          scrollToHead();
        });
        box.appendChild(b);
      });
    });
  }

  function render() {
    var r = regions[state.region];
    var matched = cards.filter(function (c) { return matches(c, state.region, state.service, state.tier); });
    var total = matched.length;
    if (state.shown === 0) state.shown = step();
    var visible = Math.min(state.shown, total);

    cards.forEach(function (c) { c.classList.remove('is-show'); });
    matched.forEach(function (c, i) { if (i < visible) c.classList.add('is-show'); });
    Object.keys(tierHeads).forEach(function (key) {
      tierHeads[key].hidden = !matched.slice(0, visible).some(function (c) { return c.getAttribute('data-tier') === key; });
    });

    /* 見出し */
    headLabel.textContent = r.label;
    headEn.textContent = r.en;
    headCount.textContent = '（' + total + '件）';

    /* ナビ */
    areaBtns.forEach(function (b) {
      var on = b === r.btn;
      b.classList.toggle('is-active', on);
      if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    serviceBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sl-service') === state.service ? 'true' : 'false');
    });
    tierBtns.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-sl-tier') === (state.tier || 'all') ? 'true' : 'false');
    });

    /* さらに表示 */
    var rest = total - visible;
    if (rest > 0) {
      moreLabel.textContent = (root.getAttribute('data-more-label') || 'さらに表示する（残り{n}件）').replace('{n}', rest);
      moreWrap.hidden = false;
    } else {
      moreWrap.hidden = true;
    }

    /* 0件表示 */
    list.hidden = total === 0;
    emptyArea.hidden = !(r.count === 0);
    emptyFilter.hidden = !(r.count > 0 && total === 0);
    if (!emptyArea.hidden) {
      setAreaNames(emptyArea, r.name);
      renderNearby(emptyArea, false);
    }
    if (!emptyFilter.hidden) {
      setAreaNames(emptyFilter, r.name);
      var conds = [];
      if (state.service !== 'all') conds.push(root.getAttribute('data-cond-service-label') + '：' + serviceLabel(state.service));
      if (state.tier) conds.push(root.getAttribute('data-cond-tier-label') + '：' + tierLabel(state.tier));
      emptyFilter.querySelector('[data-sl-cond]').textContent = conds.join(' / ');
      renderNearby(emptyFilter, true);
    }
  }

  function setRegion(key, updateHash) {
    if (!regions[key]) return;
    state.region = key;
    state.shown = 0;
    if (updateHash && window.history && history.replaceState) {
      /* プレビュー用 iframe（about:srcdoc）等では例外になるため、失敗しても表示は続ける */
      try { history.replaceState(null, '', '#' + key); } catch (e) {}
    }
    render();
  }

  function scrollToHead() {
    var top = head.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.6) {
      head.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  /* --- イベント --- */
  areaBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      setRegion(btn.getAttribute('data-sl-region'), true);
      if (SP_QUERY.matches) scrollToHead();
    });
  });

  serviceBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      state.service = btn.getAttribute('data-sl-service');
      state.shown = 0;
      render();
    });
  });

  tierBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var t = btn.getAttribute('data-sl-tier');
      state.tier = t === 'all' ? null : t;
      state.shown = 0;
      render();
    });
  });

  root.querySelector('[data-sl-reset]').addEventListener('click', function () {
    state.service = 'all';
    state.tier = null;
    state.shown = 0;
    render();
  });

  moreBtn.addEventListener('click', function () {
    var first = state.shown;
    state.shown += step();
    render();
    /* 追加分の先頭へフォーカスを移す（キーボード・スクリーンリーダー向け） */
    var shownCards = list.querySelectorAll('.psc.is-show');
    var target = shownCards[first] && shownCards[first].querySelector('a, h3, h4');
    if (target) {
      if (!target.hasAttribute('tabindex') && target.tagName !== 'A') target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }
  });

  /* 区分カードの「この区分の店舗を見る」（別セクション） */
  Array.prototype.forEach.call(document.querySelectorAll('[data-sl-tier-link]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      state.tier = a.getAttribute('data-sl-tier-link');
      state.shown = 0;
      render();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ページ内リンク等でハッシュが変わったとき（#kinki など） */
  window.addEventListener('hashchange', function () {
    var key = location.hash.replace('#', '');
    if (regions[key]) {
      setRegion(key, false);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* 画面幅が PC/SP をまたいだら表示件数を振り直す */
  var onBreakpoint = function () { state.shown = 0; render(); };
  if (SP_QUERY.addEventListener) SP_QUERY.addEventListener('change', onBreakpoint);
  else if (SP_QUERY.addListener) SP_QUERY.addListener(onBreakpoint);

  /* --- 初期表示: ハッシュの地域 → なければ店舗が1件以上ある最初の地域 --- */
  var hashKey = location.hash.replace('#', '');
  var initKey = regions[hashKey] ? hashKey : null;
  if (!initKey) {
    for (var i = 0; i < regionOrder.length; i++) {
      if (regions[regionOrder[i]].count > 0) { initKey = regionOrder[i]; break; }
    }
  }
  setRegion(initKey || regionOrder[0], false);
  if (regions[hashKey]) {
    /* id="kinki" 等の要素は無いのでブラウザは自動でスクロールしない。検索欄まで移動する */
    root.scrollIntoView({ block: 'start' });
  }
})();
